
import image from './WhatsApp Image 2024-12-18 at 19.10.04.jpeg'
import I1 from './S.png'

import { FaFacebookF, FaInstagram, FaGithub } from 'react-icons/fa';
import { IoLogoTiktok } from "react-icons/io5";
import styles from './styles.module.css';
import { SiI18Next } from 'react-icons/si';


function Main() {
  
  return (
    <div className={styles.App}>

      <div className={styles.image__div}>
        <img src={image} className={styles.image}/>
        <img src={I1} className={styles.logo}/>
      </div>
      
      <div className={styles.wrapper}>
      <h1>Amelie Studio</h1>
      <h2>Visita mis redes</h2>
          <div className={styles.wrapper_links}>
            
            <div className={styles.btn_links}>
              <a className={`${styles.social_link} ${styles.social_link_github}`} href="https://www.tiktok.com/@studioamelie3" target="_blank" rel="noopener noreferrer">
                <IoLogoTiktok  className={styles.social_icon} />
                <IoLogoTiktok  className={styles.social_icon1} />
                <IoLogoTiktok  className={styles.social_icon2} />
              </a>
            </div>
            <div className={styles.btn_links}>
              <a className={`${styles.social_link} ${styles.social_link_instagram}`} href="https://www.instagram.com/amelie_belleza_facial/profilecard/?igsh=dXc5MmRwMHo2ODly" target="_blank" rel="noopener noreferrer">  
                <FaInstagram className={styles.social_icon} />
              </a>
            </div>
            <div className={styles.btn_links}>
              <a className={`${styles.social_link} ${styles.social_link_linkedin}`} href="https://www.facebook.com/share/18PbQm1h79/?mibextid=wwXIfr">
                <FaFacebookF className={ styles.social_icon} />
              </a>
            </div>
          </div>
        </div>
    </div>
  );
}

export default Main;
